import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Reseller} from "../models/reseller.model";
import {BehaviorSubject, Subject} from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class ResellersService {

    resellers: Reseller[];
    resellers$: BehaviorSubject<Reseller[]> = new BehaviorSubject<Reseller[]>([]);

    constructor(private http: HttpClient) {
        this.http.get<Reseller[]>(environment.serverData + 'api_v1/resellers').subscribe(resellers => {
            this.resellers = resellers;

            this.resellers.map(reseller => {
                reseller.emails.map(email => {
                    if (email.type === 'service') {
                        reseller.serviceEmail = email.email;
                    }
                    if (email.type === 'main') {
                        reseller.mainEmail = email.email;
                    }
                });
            })
            this.resellers$.next(this.resellers);
        })
    }
}
